import { chatHistoryItemBorderColor } from 'globals/colors';

export default {
  anonWrapper: {
    color: '#000000',
    height: 108,
    padding: '25px 18px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    flexDirection: 'row',
    fontSize: 12,
    borderBottom: `1px solid ${chatHistoryItemBorderColor}`,
  },
  messageColumn: {
    flex: '1 auto',
    width: '79%',
    marginLeft: 10,
  },
  filler: {},
  fillerRowOne: {
    background: '#E9E9E9',
    height: 10,
    width: '15%',
  },
  fillerRowTwo: {
    background: '#E9E9E9',
    height: 10,
    width: '100%',
    marginTop: 8,
  },
  fillerRowThree: {
    background: '#E9E9E9',
    height: 10,
    width: '81%',
    marginTop: 8,
  },
};
